var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.6332 198.763C67.3944 197.017 43.7685 185.722 26.5609 167.177C9.35328 148.631 -0.143692 124.227 0.0016418 98.9284C0.146976 73.6298 9.9237 49.3365 27.3432 30.9898C44.7628 12.643 68.5169 1.62078 93.7741 0.164893L94.3466 10.0984C71.6152 11.4087 50.2365 21.3287 34.5589 37.8408C18.8813 54.3528 10.0823 76.2168 9.95148 98.9856C9.82068 121.754 18.368 143.718 33.8548 160.409C49.3417 177.1 70.605 187.265 93.3198 188.836L92.6332 198.763Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.367 0.23722C131.606 1.98321 155.232 13.2776 172.439 31.8233C189.647 50.3689 199.144 74.7729 198.998 100.072C198.853 125.37 189.076 149.664 171.657 168.01C154.237 186.357 130.483 197.379 105.226 198.835L104.653 188.902C127.385 187.591 148.763 177.671 164.441 161.159C180.119 144.647 188.918 122.783 189.049 100.014C189.179 77.2457 180.632 55.282 165.145 38.591C149.658 21.8999 128.395 11.7349 105.68 10.1635L106.367 0.23722Z",
    fill: "#60B200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceProcessing);
export default __webpack_public_path__ + "static/media/invoiceProcessing.11c0a821ea49f5561398199663b8f0c1.svg";
export { ForwardRef as ReactComponent };